var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "eq-wrapper" },
    _vm._l(_vm.bars, function (n) {
      return _c("span", {
        key: n,
        staticClass: "eq-bar",
        style: { animationDelay: `${(n - 1) * 120}ms` },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }